module.exports = __webpack_public_path__ + "static/media/calendar-icon.761c4614.svg";